// skipcq: JS-W1028, JS-0128
import React, { useEffect, useContext, useCallback, useState } from 'react';
// libs
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth, logout } from '../../utils/firebase';
import { useNavigate } from 'react-router-dom';
// context
import { UserContext } from '../../context/UserContext';
// material UI
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

export default function IttAppBar({ title }) {
  const [loading] = useAuthState(auth);
  const navigate = useNavigate();

  const user = useContext(UserContext);
  const { isGlobalAdmin } = user;

  // menu handlers
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = useCallback((event) => {
    setAnchorEl(event.currentTarget);
  }, []);
  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  useEffect(() => {
    if (loading) {
      // maybe trigger a loading screen
      return;
    }
    if (!user) navigate('/home');
  }, [user, loading, navigate]);

  // Memoized callbacks to avoid recreating on every render
  const handleNavigateToBreweries = useCallback(() => {
    navigate('/breweries');
  }, [navigate]);

  const handleNavigateToNhStyleFingerprints = useCallback(() => {
    setAnchorEl(null);
    navigate('/nh-style-fingerprints');
  }, [navigate]);

  const handleNavigateToUsers = useCallback(() => {
    navigate('/users');
  }, [navigate]);

  const handleNavigateToFailures = useCallback(() => {
    navigate('/failures');
  }, [navigate]);

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
            onClick={handleClick}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            {title}
          </Typography>
          {user ? (
            <Button color="inherit" onClick={logout}>
              Logout
            </Button>
          ) : null}
        </Toolbar>
      </AppBar>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        aria-labelledby="basic-demo-button"
      >
        {isGlobalAdmin && (
          <MenuItem onClick={handleNavigateToBreweries}>Breweries</MenuItem>
        )}
        {isGlobalAdmin && (
          <MenuItem onClick={handleNavigateToNhStyleFingerprints}>
            NH style fingerprints
          </MenuItem>
        )}
        {isGlobalAdmin && (
          <MenuItem onClick={handleNavigateToUsers}>Users</MenuItem>
        )}
        {isGlobalAdmin && (
          <MenuItem onClick={handleNavigateToFailures}>Data Issues</MenuItem>
        )}
        <MenuItem onClick={logout}>Logout</MenuItem>
      </Menu>
    </Box>
  );
}
